import React from "react";
import Grid from "@material-ui/core/Grid/Grid";
import withStyles from "@material-ui/core/styles/withStyles";

function Parameter({ classes, label, children }) {
    return <Grid item lg={6} xs={12} className={classes.paramBlock}>
        <Grid container>
            <Grid item xs={6} className={classes.paramLabel}>
                {label}
            </Grid>
            <Grid item xs={6} className={classes.paramValue}>
                {children}
            </Grid>
        </Grid>
    </Grid>
}

const styles = (theme) => ({
    paramBlock: {
      fontSize: "14px",
      marginBottom: "1%",
    },
    paramValue: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      textAlign: "left",
      paddingLeft: "3%",
    },
    paramLabel: {
      textAlign: "right",
      borderRight: `1px solid ${theme.palette.grey["A400"]}`,
      paddingRight: "3%",
    },
});

export default withStyles(styles, { withTheme: true })(Parameter)


// WEBPACK FOOTER //
// ./src/containers/Portfolio/components/Parameter.jsx